import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getGlobalInvitationNotifications: {
    method: 'GET',
    url: `${configs.baseUrl}/api/invitations?status={status}&email={invitedEmail}`,
  },
  getInvitations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/invitations`,
  },
  createInvitations: {
    method: 'POST',
    url: `${configs.baseUrl}/api/invitations`,
  },
  patchInvitation: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/invitations/{invitationId}`,
  },
  acceptInvitation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/invitations/{invitationId}/accept`,
  },
  declineInvitation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/invitations/{invitationId}/decline`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getGlobalInvitationNotifications = async ({ status, invitedEmail }) => {
  const res = await resource.getGlobalInvitationNotifications({ status, invitedEmail })
  return res.body.invitations
}

const getInvitations = async () => {
  const res = await resource.getInvitations()
  return res.body.invitations
}

const createInvitations = async (params) => {
  const res = await resource.createInvitations(params)
  return res.body.invitation
}

const patchInvitation = async (invitationId, params) => {
  const res = await resource.patchInvitation({ invitationId }, params)
  return res.body.invitation
}

const acceptInvitation = async (invitationId) => {
  const res = await resource.acceptInvitation({ invitationId }, null)
  return res.body
}

const declineInvitation = async (invitationId) => {
  const res = await resource.declineInvitation({ invitationId }, null)
  return res.body
}

export default {
  initResource,
  getGlobalInvitationNotifications,
  getInvitations,
  createInvitations,
  patchInvitation,
  acceptInvitation,
  declineInvitation,
}
